/**
 * The exclusive upper bound a calendar `dueDate` must fall below to count as
 * overdue: today's calendar day at UTC midnight.
 *
 * The API serialises `dueDate` as a calendar date ("2026-09-17"), which
 * deserialises to midnight UTC. Comparing that against `new Date()` makes
 * everything due today overdue from one minute past midnight onwards, so the
 * boundary has to be a day, not an instant. The day is taken from the viewer's
 * local calendar and lifted to UTC so it lines up with how the value is stored.
 */
export const getOverdueBoundary = (now: Date = new Date()): Date =>
  new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()));
